import { Component, type OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../services/security/authentication.service";
import * as toastr from "toastr";

@Component({
    templateUrl: "./verify-pin.component.html",
    styleUrl: "./verify-pin.component.scss",
})
export class VerifyPinComponent implements OnInit {
    public isWaiting = false;
    public verifyPinForm: FormGroup;
    public isButtonDisabled = false;
    public countdown = 0;
    public errorMessage: string = null;

    private intervalId: any;
    private username: string;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authService: AuthenticationService
    ) {}

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.router.navigate(["./webhome"]);
        }
        this.username = history.state?.username;
    }

    onCodeCompleted(code: string) {
        this.errorMessage = null;
        this.authService
            .login({ pin: code, username: this.username })
            .subscribe({
                next: (res) => {
                    console.log(res);

                    if (res.length === 0) {
                        this.isWaiting = false;
                        return;
                    }
                    this.isWaiting = false;
                    this.router.navigate(["/webhome"]);
                },
                error: (error) => {
                    let errorResponse = JSON.parse(error.error);
                    this.errorMessage = errorResponse.message;
                },
            });
    }

    onChangeCode() {
        this.errorMessage = null;
    }

    resendCode() {
        if (this.isButtonDisabled) {
            return;
        }

        this.isButtonDisabled = true;
        this.countdown = 30;

        this.authService.resendPin(this.username).subscribe((res: any) => {
            if (res.type === "OK") {
                toastr.success("Pin enviado de forma exitosa.");
                this.intervalId = setInterval(() => {
                    this.countdown--;

                    if (this.countdown === 0) {
                        this.isButtonDisabled = false;
                        clearInterval(this.intervalId);
                    }
                }, 1000);
            }
        });
    }
}
